import {Raycaster, Scene, Vector2, Vector3} from 'three';
import {useARStore} from 'stores';
import {xrStore} from 'lib';

const posHelper = new Vector3();
const raycaster = new Raycaster();

/**
 * Detects 1 finger location on screen for model raycasting.
 * @returns Touched model id.
 */

const checkTouchedModel = async (scene: Scene) => {
  const frame = await xrStore.requestFrame();
  const inputSources = xrStore.getState().session?.inputSources;
  if (!inputSources || inputSources.length !== 1 || !inputSources[0]) {
    return;
  }

  const baseSpace = xrStore.getState().originReferenceSpace;
  if (!baseSpace) {
    return;
  }

  const space = inputSources[0].targetRaySpace;
  const pose = frame.getPose(space, baseSpace);
  const pos = pose?.transform?.position;
  if (!pos) {
    return;
  }

  posHelper.set(pos.x, pos.y, pos.z);

  const camera = useARStore.getState().cameraRef.current;
  const {x: screenX, y: screenY} = posHelper.project(camera);
  raycaster.setFromCamera(new Vector2(screenX, screenY), camera);

  const groups = scene.children.filter(c => c.userData.id);
  const intersects = raycaster.intersectObjects(groups);

  if (intersects.length === 0) {
    return '';
  }

  for (const intersect of intersects) {
    const id = recursiveGetId(intersect.object);
    if (id) {
      return id;
    }
  }
};

export default checkTouchedModel;

const recursiveGetId = (object: ReturnType<typeof raycaster.intersectObject>[0]['object']): string => {
  if (object?.parent) {
    const id = object.parent.userData.id as string | undefined;
    return id ?? recursiveGetId(object.parent);
  }
  return '';
};
